<script>
import Cover from "./Cover.vue";
import Btn from "./Btn.vue";
export default {
  components: {
    Cover,
    Btn
  },
  props: {
    width: {
      type: [String, Number],
      default: 349
    },
    title: String,
    simple: Boolean,
    btnText: {
      type: String,
      default: "确定"
    },
    hideClose: Boolean
  },
  computed: {
    styleWidth() {
      return parseInt(this.width) + "px";
    },
    style() {
      return {
        width: this.styleWidth,
        paddingTop: `${this.simple ? 48 : 28}px`
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<template>
  <Cover>
    <div class="Dialog" :style="style">
      <img v-if="!hideClose" class="close" @click="close" src="./assets/clear_close.svg" />
      <h1>{{title}}</h1>
      <slot>
        <div class="holder"></div>
      </slot>
      <Btn @click="confirm">{{btnText}}</Btn>
    </div>
  </Cover>
</template>


<style lang="scss" scoped>
.Dialog {
  background-color: #fff;
  border-radius: 12px;
  padding-bottom: 31px;
  position: relative;
  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    width: 18px;
    height: 18px;
  }
  > h1 {
    text-align: center;
    margin-bottom: 34px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    line-height: 25px;
  }
  > .Btn {
    margin-left: 21px;
    margin-right: 21px;
    margin-top: 15px;
    height: 48px;
    border-radius: 3px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
  }
  .holder {
    height: 12px;
  }
}
</style>




// WEBPACK FOOTER //
// yotta-vue-components/vision/Dialog.vue